import {
  setHistoryData,
  setChatInfoData,
  setHistoryLoadingInfo,
} from "./slice";

export const setHistory = (data) => (dispatch) => {
  dispatch(setHistoryData(data));
};

export const setChatInfo = (data) => (dispatch) => {
  dispatch(setChatInfoData(data));
};

export const setHistoryLoading = (data) => (dispatch) => {
  dispatch(setHistoryLoadingInfo(data));
};
